import {Injectable} from "@angular/core";
import {uuid} from '../utils/string-utils';

export class AppSession {
    id: string;
    accessed: number;
}

/**
 * This service provides storage and retrieval of the app session id
 */
@Injectable({providedIn: "root"})
export class AppSessionService {
    public static readonly LOCAL_STORAGE_KEY = "appSession";
    public static readonly SESSION_WINDOW_MS = 30 * 60 * 1000;

    private readonly storageKey: string;

    constructor() {
        console.log("--- AppSessionService");

        this.storageKey = AppSessionService.LOCAL_STORAGE_KEY;
    }

    public getAppSessionId(scanId: string): string {
        const now: Date = new Date();
        const appSession: AppSession = JSON.parse(localStorage.getItem(this.storageKey)) || {};
        if (!appSession.id || (appSession.id !== scanId && now.getTime() - appSession.accessed > AppSessionService.SESSION_WINDOW_MS)) {
            appSession.id = scanId || uuid();
        }
        appSession.accessed = now.getTime();
        localStorage.setItem(this.storageKey, JSON.stringify(appSession));
        return appSession.id;
    }
}
